import React from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnMapper } from '../../models/api/codegen/code';


type BoxHeaderProps = {
    columnMapper: ColumnMapper | undefined | null;
};

export function BoxHeader(props: BoxHeaderProps) {
    const { t } = useTranslation();
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
            {(!props.columnMapper || props.columnMapper.c1) &&
                <h4>{t('header.team1')}</h4>}
            {(!props.columnMapper || props.columnMapper.c2) &&
                <h4>{t('header.draw')}</h4>}
            {(!props.columnMapper || props.columnMapper.c3) &&
                <h4>{t('header.team2')}</h4>}
        </div>

    );
}